import '@/config/sentry';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initSurveyJsLicense } from '@/bootstrapSurveyLicense';
import './index.css';
import './styles/index.sass';
import App from './App.tsx';

initSurveyJsLicense();

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
